import React, { createRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withFormsyValidations from '../withFormsyValidations';

function getValue(event) {
  const fieldValue = event.currentTarget.value;
  let value = fieldValue;
  const parsedField = Number.parseFloat(event.currentTarget.value);

  if (!_.isNaN(parsedField)) {
    value = parsedField;
  }

  if (value === '') {
    value = null;
  }
  return value;
}
class NumberInput extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      id: PropTypes.string,
      setValue: PropTypes.func.isRequired,
      onChange: PropTypes.func,
      required: PropTypes.bool,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      errorMessage: PropTypes.string,
      isValid: PropTypes.bool.isRequired,
      step: PropTypes.number,
      isInteger: PropTypes.bool,
      disabled: PropTypes.bool,
      onBlur: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      required: false,
      disabled: false,
      value: undefined,
      step: undefined,
      isInteger: false,
      errorMessage: '',
      id: _.uniqueId(),
      onBlur: undefined,
      onChange: undefined,
    };
  }

  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.state = {
      inputValue:
        props.value === undefined || props.value === null ? '' : props.value,
    };
    this.inputRef = createRef();
  }

  componentDidUpdate(previousProps) {
    if (this.props.value && previousProps.value !== this.props.value)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ inputValue: this.props.value });
  }

  onBlurHandler(event) {
    const { name, setValue, onBlur } = this.props;
    const value = getValue(event);
    if (onBlur) {
      onBlur(name, value);
      setValue(value);
    }
  }

  onChangeHandler(event) {
    const { name, setValue, onChange } = this.props;
    const value = getValue(event);

    if (onChange) {
      onChange(name, value);
      setValue(value);
    }
    this.setState({ inputValue: value });
  }

  render() {
    // Dont remove onChange from below.
    const { name, id, errorMessage, isValid, required, step, disabled } =
      this.props;
    const { inputValue } = this.state;

    const classes = classNames({
      'input-field form-control': true,
      'border border-danger text-with': !isValid,
    });

    return (
      <div>
        <input
          className={classes}
          onFocus={event => event.target.select()}
          type="number"
          value={inputValue}
          id={id}
          step={step}
          required={required}
          disabled={disabled}
          name={name}
          ref={this.inputRef}
          onWheel={() => {
            // This sucks, but it seems to be the consensus to use blur onWheel.
            // bubbling defaults will cause issues in some browers.
            // And does not fix chrome.
            this.inputRef.current.blur();
          }}
          onChange={this.onChangeHandler}
          onBlur={this.onBlurHandler}
        />
        <span>{errorMessage}</span>
      </div>
    );
  }
}

export default withFormsyValidations(NumberInput, props => ({
  isNumeric: true,
  required(values, value) {
    if (props.required) {
      return _.isNumber(value);
    }
    return true;
  },
  max(values, value) {
    if (props.max) {
      return (value || 0) <= props.max;
    }
    return true;
  },
  min(values, value) {
    if (props.min || props.min === 0) {
      return (value || 0) >= props.min;
    }
    return true;
  },
  isInteger(values, value) {
    if (value && props.isInteger) {
      return value % 1 === 0;
    }
    return true;
  },
}));
